module.exports = __webpack_public_path__ + "fonts/fa-v2-solid-900.25c8182a.eot";